const KEYS = {
  accessToken: 'authToken',
  refreshToken: 'refreshToken',
  userId: 'user_id',
  isAuthenticated: 'isAuthenticated',
  authUser: 'authUser',
  authTimestamp: 'authTimestamp',
};

export function getAccessToken() {
  try { return localStorage.getItem(KEYS.accessToken); } catch { return null; }
}

export function getRefreshToken() {
  try { return localStorage.getItem(KEYS.refreshToken); } catch { return null; }
}

export function getUserId() {
  try { return localStorage.getItem(KEYS.userId) || 'anonymous'; } catch { return 'anonymous'; }
}

export function getAuthUser() {
  try {
    const raw = localStorage.getItem(KEYS.authUser);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function setTokens({ access_token, refresh_token, user_id }) {
  try {
    if (access_token) localStorage.setItem(KEYS.accessToken, access_token);
    if (refresh_token) localStorage.setItem(KEYS.refreshToken, refresh_token);
    if (user_id) localStorage.setItem(KEYS.userId, user_id);
  } catch { /* storage unavailable */ }
}

export function setAuthState(user) {
  try {
    localStorage.setItem(KEYS.isAuthenticated, 'true');
    localStorage.setItem(KEYS.authUser, JSON.stringify(user));
    localStorage.setItem(KEYS.authTimestamp, String(Date.now()));
  } catch { /* storage unavailable */ }
}

export function clearAuth() {
  try {
    Object.values(KEYS).forEach((k) => localStorage.removeItem(k));
  } catch { /* storage unavailable */ }
}

export function isLoggedIn() {
  try { return localStorage.getItem(KEYS.isAuthenticated) === 'true'; } catch { return false; }
}
